import React, { useEffect, useRef, useState } from "react";
import styles from "src/Assets/css/home/Feed.module.css";
import attachIcon from "src/Assets/images/attachIcon.png";
import attachIconAfterUpload from "src/Assets/images/attachIconAfterUpload.png";
import closeIcon from "src/Assets/images/CloseButton.svg";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import sampledialogcancel from "src/Assets/images/Add.png";
import { Modal, Box } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import FileSizeAlertModal from "./AttachmentSizeAlertModel";
import Popover from "@mui/material/Popover";

const AttachmentUploader = ({
  onFileSelect,
  allowMultiple = false,
  showPreview = true,
  docName = null,
  docLocation = null,
  onDeleteAttachment,
  editPostId,
  setShowAlertMessage,
  disabled = false,
  isPostOption,
  readOnly
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const fileInputRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [clickedFile, setClickedFile] = useState(null);

  const hasSelected = selectedFiles.length > 0;
  const hasExisting = Boolean(docName && docName.trim());
  const [showSizeAlert, setShowSizeAlert] = useState(false);

  const MAX_SIZE = 2 * 1024 * 1024; // 2 MB

  useEffect(() => {
    setSelectedFiles([]);
  }, [isPostOption]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (!allowMultiple) {
      const file = files[0];
      if (!file) return;

      if (file.size > MAX_SIZE) {
        setShowSizeAlert(true); // open modal
        setSelectedFiles([]);
        onFileSelect(null);
      } else {
        setSelectedFiles([file]);
        onFileSelect(file);
      }
    } else {
      let valid = [];
      let invalid = false;

      files.forEach((file) => {
        if (file.size > MAX_SIZE) invalid = true;
        else valid.push(file);
      });

      if (invalid) {
        setShowSizeAlert(true); // open modal
      }

      const updated = [...selectedFiles, ...valid];
      setSelectedFiles(updated);
      onFileSelect(updated);
    }

    e.target.value = "";
  };

  // const handleFileChange = (e) => {
  //   const files = Array.from(e.target.files);

  //   if (allowMultiple) {
  //     setSelectedFiles((prev) => [...prev, ...files]);
  //     onFileSelect([...selectedFiles, ...files]);
  //   } else {
  //     const file = files[0];
  //     if (file) {
  //       setSelectedFiles([file]);
  //       onFileSelect(file);
  //     }
  //   }
  //   // Reset file input so user can re-select same file later
  //   e.target.value = "";
  // };

  // Prepare list of files to display in preview
  const filesToShow =
    selectedFiles.length > 0
      ? selectedFiles.map((file) => ({ name: file.name, isNew: true, file }))
      : docName
      ? [{ name: docName, isNew: false, docLocation }]
      : [];

  const handleRemoveFile = (index) => {
    const updated = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updated);
    onFileSelect(allowMultiple ? updated : null);

    // Also reset the file input value
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <>
      <div className={styles.attachmentContainer}>
        {/* Icon + File names in same line */}
        <label
          className={styles.iconLabel}
          onClick={(e) => {
            if (disabled || readOnly) {
              e.preventDefault(); // stops file chooser
              if (disabled && setShowAlertMessage) {
                setShowAlertMessage(true);
              }
            }
          }}
          style={{
            cursor: disabled || readOnly ? "not-allowed" : "pointer",
          }}
        >
          <Tooltip title="Add Attachment" arrow>
            <img
              src={
                hasSelected || hasExisting ? attachIconAfterUpload : attachIcon
              }
              alt="attach"
              className={styles.attachIcon}
              style={{
                cursor: disabled || readOnly ? "not-allowed" : "pointer",
                opacity: readOnly ? 0.7 : 1,
              }}
            />
          </Tooltip>
          <input
            ref={fileInputRef}
            type="file"
            accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
            style={{ display: "none" }}
            onChange={handleFileChange}
            multiple={allowMultiple}
            disabled={disabled || readOnly}
          />
        </label>

        {/* File name(s) next to icon */}
        {showPreview && filesToShow.length > 0 && (
          <div className={styles.fileList}>
            {filesToShow.map((file, index) => (
              <div key={index} className={styles.fileItem}>
                {/* <span className={styles.fileName}>{file.name}</span> */}
                <span
                  className={styles.fileName}
                  onClick={(e) => {
                    setClickedFile(file);
                    setAnchorEl(e.currentTarget);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {file.name}
                </span>
                <button
                  type="button"
                  onClick={() => {
                    if (file.isNew) {
                      handleRemoveFile(index);
                    } else {
                      setDeleteConfirmationModal(true);
                    }
                  }}
                  className={styles.removeBtn}
                >
                  <img
                    src={closeIcon}
                    alt="closeIcon"
                    className={styles.deleteIcon}
                  />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <Modal
        onClose={() => setDeleteConfirmationModal(false)}
        open={deleteConfirmationModal}
        aria-labelledby="delete-confirmation-title"
        aria-describedby="delete-confirmation-description"
        sx={{
          zIndex: 3500,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            outline: "none",
            boxShadow: 24,
            minWidth: 300,
          }}
        >
          <div className={feedstyles.sampledialogcountandcancel}>
            <p>
              <b>Delete Confirmation</b>
            </p>
            <a onClick={() => setDeleteConfirmationModal(false)}>
              <img src={sampledialogcancel} alt="" />
            </a>
          </div>
          <div>
            <p>Are you sure you want to delete this Attachment?</p>

            <button
              onClick={() => {
                onDeleteAttachment(editPostId);
                setDeleteConfirmationModal(false);
              }}
              className={feedstyles.dialogdeletebutton}
            >
              Delete
            </button>
          </div>
        </Box>
      </Modal>
      <FileSizeAlertModal
        open={showSizeAlert}
        onClose={() => setShowSizeAlert(false)}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{
          zIndex: 3500,
        }}
      >
        <Box sx={{ p: 1.5, display: "flex", flexDirection: "column", gap: 1 }}>
          {/* VIEW FILE */}
          <button
            className={styles.popoverBtn}
            onClick={() => {
              if (!clickedFile) return;
              if (clickedFile.isNew && clickedFile.file) {
                const url = URL.createObjectURL(clickedFile.file);
                window.open(url, "_blank");
              } else if (clickedFile.docLocation) {
                const baseUrl = process.env.REACT_APP_SKOPIC_IMAGE_OTHER;
                const fileUrl = clickedFile.docLocation.startsWith("blob:")
                  ? clickedFile.docLocation
                  : `${baseUrl}${clickedFile.docLocation}`;
                window.open(fileUrl, "_blank", "noopener,noreferrer");
              }
              setAnchorEl(null);
            }}
          >
            View
          </button>

          {/* DOWNLOAD FILE */}
          <button
            className={styles.popoverBtn}
            onClick={async () => {
              if (!clickedFile) return;
              if (clickedFile.isNew && clickedFile.file) {
                const url = URL.createObjectURL(clickedFile.file);
                const a = document.createElement("a");
                a.href = url;
                a.download = clickedFile.name;
                a.click();
              } else if (clickedFile.docLocation) {
                const baseUrl = process.env.REACT_APP_SKOPIC_IMAGE_OTHER;
                const fileUrl = clickedFile.docLocation.startsWith("blob:")
                  ? clickedFile.docLocation
                  : `${baseUrl}${clickedFile.docLocation}`;
                const downloadUrl = fileUrl.includes("?")
                  ? `${fileUrl}&download=true`
                  : `${fileUrl}?download=true`;
                try {
                  const response = await fetch(downloadUrl, { mode: "cors" });
                  const blob = await response.blob();
                  const blobUrl = window.URL.createObjectURL(blob);
                  const link = document.createElement("a");
                  link.href = blobUrl;
                  link.download = clickedFile.name;
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                  window.URL.revokeObjectURL(blobUrl);
                } catch (error) {
                  console.error("Download failed:", error);
                }
              }
              setAnchorEl(null);
            }}
          >
            Download
          </button>
        </Box>
      </Popover>
    </>
  );
};

export default AttachmentUploader;
